'use client'

import MailingList from '@/app/components/MailingList';

export default function ContactPage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-lg">
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-xl font-bold">Contact Us</h2>
        </div>
        <p className="text-gray-600 mb-4">
          Subscribe to our mailing list to stay updated with our latest news and updates!
        </p>
        <MailingList 
          onSuccess={() => {
            alert('Thanks for subscribing! We\'ll be in touch soon.');
          }} 
          uniqueId="contact-modal" 
        />
      </div>
    </main>
  );
} 